export default __webpack_public_path__ + "14da6beae64d62f1f8d9147fbd2e621a.png";